import { createContext, useContext, useState, useCallback } from 'react';
import { mockUser, mockOrganizations } from '@/lib/mock-data';

const AuthContext = createContext(undefined);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(mockUser);
  const [isAuthenticated, setIsAuthenticated] = useState(true); // Default to true for demo
  const [currentOrganization, setCurrentOrganization] = useState(mockOrganizations[0]);
  const [organizations] = useState(mockOrganizations);
  const [isLoading, setIsLoading] = useState(false);

  const login = useCallback(async (email, password) => {
    setIsLoading(true);
    // Simulate API call
    await new Promise((resolve) => setTimeout(resolve, 500));
    setUser(mockUser);
    setIsAuthenticated(true);
    setIsLoading(false);
    return { success: true };
  }, []);

  const signup = useCallback(async (data) => {
    setIsLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 500));
    setUser({ ...mockUser, ...data });
    setIsAuthenticated(true);
    setIsLoading(false);
    return { success: true };
  }, []);

  const logout = useCallback(async () => {
    setIsLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 200));
    setUser(null);
    setIsAuthenticated(false);
    setIsLoading(false);
  }, []);

  const switchOrganization = useCallback((orgId) => {
    const org = organizations.find((o) => o.id === orgId);
    if (org) {
      setCurrentOrganization(org);
    }
  }, [organizations]);

  const value = {
    user,
    isAuthenticated,
    isLoading,
    currentOrganization,
    organizations,
    login,
    signup,
    logout,
    switchOrganization,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
